import type { RouteRecordRaw } from 'vue-router'
import Docs from '@/views/docs/Docs.vue'

const docsRoutes: RouteRecordRaw[] = [
  {
    path: '/docs',
    name: 'Docs',
    component: Docs,
    meta: {
      requiresAuth: true,
      requiredItem: 'docs',
      title: 'Documentações',
      breadcrumbTitle: 'Documentações'
    }
  }
]

export default docsRoutes


